"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _labelLike = _interopRequireDefault(require("./label-like.css"));

var _excluded = ["children", "className", "light", "inline"];

var LabelLike = function LabelLike(_ref) {
  var _clsx;

  var children = _ref.children,
      className = _ref.className,
      light = _ref.light,
      inline = _ref.inline,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, props, {
    className: (0, _clsx2["default"])(_labelLike["default"].labelLike, (_clsx = {}, _clsx[_labelLike["default"].inline] = inline, _clsx[_labelLike["default"].light] = light, _clsx), className)
  }), children);
};

var _default = LabelLike;
exports["default"] = _default;